




















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import RecentlyView from '@/components/organisms/item-list/recently-viewed/RecentlyViewed.vue'
import ApiBrand from '@/models/api/brand'
import FavoriteItemsView from '@spa/components/templates/FavoriteItems.vue'
import FavoriteItemsByBrandView from '@spa/components/templates/FavoriteItemsByBrand.vue'

const TAB_ITEM = {
  Favorite: 'favorite',
  CheckedItem: 'checkeditem',
} as const

@Component({
  components: {
    FavoriteItemsView,
    FavoriteItemsByBrandView,
    RecentlyView,
  },
})

export default class MyColorItems extends Vue {

  @Prop({ required: true })
  brands: ApiBrand[]

  @Prop({ default: null })
  initialBrandId: string | null

  selectedTab: string = TAB_ITEM.Favorite

  get initialBrandExists(): boolean {
    return this.initialBrandId !== null
  }

  get showFavorite(): boolean {
    return this.selectedTab === TAB_ITEM.Favorite
  }

  get showCheckedItem(): boolean {
    return this.selectedTab === TAB_ITEM.CheckedItem
  }
}
